import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import SearchField from 'components/atoms/SearchField'
import DataTable from 'components/organisms/DataTable'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import DropdownSelect from 'components/molecules/DropdownSelect'
import PaginationControl from 'components/organisms/PaginationControl'

import { trapColumns } from './'
import { DATE_DROPDOWN_OPTIONS } from 'constants/tables'

const styles = theme => ({
  root: {
    marginBottom: theme.spacing(1),
  },
  table: {
    marginTop: theme.spacing(6),
  },
  menu: {
    width: 180,
  },
  content: {
    flex: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  submitButton: {
    marginLeft: theme.spacing(3),
  },
})


const TrapDataOverview = ({
  traps,
  classes,
  filters,
  tableLoading,
  onPageChange,
  onExportClick,
  onRangeChange,
  selectedRange,
  onSearchChange,
  onTableRowClick,
  onTableSortClick,
  onTableSelectableClick,
  setFilters,
  onToggle,
  showArchived,
}) => {

  const handleToggle = () => {
    setFilters({ active: showArchived })
    onToggle()
  }

  
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <div className={classes.header}>
          <DropdownSelect
            text="Total data for "
            selected={selectedRange}
            onChange={onRangeChange}
            options={DATE_DROPDOWN_OPTIONS}
          />
          <div className={classes.header}>
            <SearchField onChange={onSearchChange} width={110}/>
            <SubmitButton
                size="medium"
                type="submit"
                color="primary"
                variant="primary"
                onClick={onExportClick}
                className={classes.submitButton}>
              Download reports...
            </SubmitButton>
          </div>
        </div>
        <DataTable
          isArchived={showArchived}
          hasArchivedCheckbox
          handleArchivedToggle={handleToggle}
          key="Group table"
          dataProvider={traps}
          columns={trapColumns}
          className={classes.table}
          tableLoading={tableLoading}
          onRowClick={onTableRowClick}
          onSortClick={onTableSortClick}
          emptyStateLinkLabel="Invite contributors"
          emptyStateLinkTo="/dashboard/people/all"
          onSelectableClick={onTableSelectableClick}
          emptyStateTitle="Looks like there are no traps added yet"
          emptyStateDescription="Get started by sharing an invite code with Goodnature Chirp App users so they can share traps with you"
        />
        <PaginationControl
          pagination={filters.pagination}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  )
}


TrapDataOverview.propTypes = {
  traps: PropTypes.object,
  filters: PropTypes.object,
  classes: PropTypes.object,
  onTabClick: PropTypes.func,
  tableLoading: PropTypes.bool,
  onPageChange: PropTypes.func,
  onExportClick: PropTypes.func,
  onRangeChange: PropTypes.func,
  onSearchChange: PropTypes.func,
  selectedRange: PropTypes.object,
  onTableRowClick: PropTypes.func,
  onTableSortClick: PropTypes.func,
  onTableSelectableClick: PropTypes.func,
  setFilters: PropTypes.func, 
  onToggle: PropTypes.func,
  showArchived: PropTypes.bool,
}

export default withStyles(styles)(TrapDataOverview)



// WEBPACK FOOTER //
// ./src/containers/traps/TrapDataOverview/TrapDataOverview.js